<nav aria-label="Page navigation" class="mt-6 w-full overflow-hidden">
    <div class="flex flex-col md:flex-row justify-between md:items-center gap-2">
        <!-- Itens por página à esquerda em desktop e abaixo em mobile -->
        <div class="ml-4 md:ml-0 order-2 md:order-1 w-full md:w-auto">
            <ui-list [placeHolder]="'Itens por página'" [editable]="true" [type]="EList.DROPDOWN" [default]="10"
                (valueChange)="onItemsPerPageChange($event)" [choice]="Options"></ui-list>
        </div>

        <!-- Paginação à direita em desktop e acima em mobile -->
        <ul class="inline-flex -space-x-px text-sm w-full md:w-auto order-1 md:order-2 justify-center md:justify-start">
            <li>
                <div href="#" (click)="goBefore()"
                    class="flex items-center justify-center px-3 h-8 ms-0 leading-tight text-gray-500 bg-white border border-e-0 border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                    <span class="hidden md:block">Anterior</span>
                    <span class="block md:hidden">
                        <ui-icon [icon]="EIcon.AngleLeft" [size]="EComponentSize.Small" [color]="EAlert.DARK"></ui-icon>
                    </span>
                </div>
            </li>

            @for (page of pages; track $index) {
                @if(page >= (current() - 2) && page <= (current() + 2)){ 
                <li (click)="goTo(page)">
                    <div href="#" [attr.aria-current]="page == current()?'page':''"
                        [class.leading-tight]="page != current()" 
                        [class.text-gray-500]="page != current()"
                        [class.bg-white]="page != current()" 
                        [class.hover:bg-gray-100]="page != current()"
                        [class.hover:text-gray-700]="page != current()" 
                        [class.dark:bg-gray-800]="page != current()"
                        [class.dark:text-gray-400]="page != current()" 
                        [class.dark:hover:bg-gray-700]="page != current()"
                        [class.dark:hover:text-white]="page != current()" 
                        [class.text-blue-600]="page == current()"
                        [class.bg-blue-50]="page == current()" 
                        [class.hover:bg-blue-100]="page == current()"
                        [class.hover:text-blue-700]="page == current()" 
                        [class.dark:bg-gray-700]="page == current()"
                        [class.dark:text-white]="page == current()"
                        class="flex items-center justify-center px-3 h-8 border border-gray-300 dark:border-gray-700">
                        {{page}}
                    </div>
                </li>
                }
            }
            
            <li>
                <div href="#" (click)="goNext()"
                    class="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                    <span class="hidden md:block">Próximo</span>
                    <span class="block md:hidden">
                        <ui-icon [icon]="EIcon.AngleRight" [size]="EComponentSize.Small" [color]="EAlert.DARK"></ui-icon>
                    </span>
                </div>
            </li>
        </ul>
    </div>
</nav>
